import React, { useState } from 'react'
import '@wojtekmaj/react-daterange-picker'
import propTypes from 'prop-types'
import moment from 'moment'
import Calendar from 'react-calendar'

/*
 * Generic component for date-range picking
 * 1 callback function is necessary: onRangeSelect
 * it will receive as cb parameters 2 moment.js objects
 */

function DaterangePicker(props) {
  const { t } = props

  const [value, onChange] = useState(0)
  const [isOpen, setOpen] = useState(true)
  const [pseudoValue, setPseudoValue] = useState(0) // used for temporary date selection, if user cancels this turns back to the selected value

  const dateString = pseudoValue
    ? `${moment(pseudoValue[0]).format('DD/MM/YYYY')} - ${moment(
        pseudoValue[1]
      ).format('DD/MM/YYYY')}`
    : ''

  const handleChange = (dates) => {
    setPseudoValue(dates)
  }

  const handleSubmit = () => {
    const { onRangeSelect } = props
    const [dtStart, dtEnd] = pseudoValue

    onChange(pseudoValue)
    onRangeSelect && onRangeSelect(moment(dtStart), moment(dtEnd))
    setOpen(false)
  }

  const handleCancel = () => {
    setPseudoValue(value)
    setOpen(false)
  }

  const formatDate = (date) => moment(date).format('MMMM YYYY')

  return (
    <>
      <img
        className='icon'
        src='images/calendar.svg'
        onClick={() => setOpen(!isOpen)}
      />
      {isOpen && (
        <div className='rangepicker'>
          <div>
            <p className='datestring-display'>{dateString}</p>
            <Calendar
              value={pseudoValue}
              calendarType={'US'}
              formatMonthYear={(locale, date) => formatDate(date)}
              onChange={handleChange}
              className='react-calendar'
              returnValue='range'
              selectRange
            />
          </div>

          <div className='submit-buttons'>
            <button
              onClick={() => handleCancel()}
              className='left button-hollow button-hollow-primary'
            >
              {t('cancel_button')}
            </button>
            <button
              disabled={!pseudoValue}
              onClick={() => handleSubmit()}
              className='right button button-primary'
            >
              {t('priceBannerFiltersActivity.apply')}
            </button>
          </div>
        </div>
      )}
    </>
  )
}

DaterangePicker.propTypes = {
  onRangeSelect: propTypes.func,
  isOpen: propTypes.bool,
  t: propTypes.func,
}

export default DaterangePicker
